module.exports = __webpack_public_path__ + "static/media/ManorleadLogo.b6ed5f68.png";